import { DataSource, Layout, LayoutHeader, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageWorkflowProfileList extends Layout {
    layoutheaderBrokWorkflowProfileList: LayoutHeader;
    panelBrokerageWorkflowProfileList: Panel;
    sourceBrokerageWorkflow: DataSource;
    tableBrokerageWorkflowProfile: Table;
}
